import { createContext, useContext } from 'react'

export type ToastTone = 'success' | 'error' | 'info'

export interface ToastApi {
  push: (message: string, tone?: ToastTone) => void
  success: (message: string) => void
  error: (message: string) => void
}

export const ToastContext = createContext<ToastApi | null>(null)

const noopApi: ToastApi = {
  push: () => undefined,
  success: () => undefined,
  error: () => undefined,
}

export function useToast(): ToastApi {
  return useContext(ToastContext) ?? noopApi
}
